import type { Xapi } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    xapi: Xapi | null;
    uniqueId: string;
    isReadOnly: boolean;
  };
}

const XapiSection: TemplateOnlyComponent<Signature> = <template>
  <h3 class="gud-eyebrow">Learning Record Store</h3>
  <p>
    When users interact with content, their learning activities are recorded in
    a Learning Record Store (LRS). This will be shown in their learning record
    on Leadership Live and can be used to track their progress and achievements.
    It is also used for client reporting and analytics.
  </p>

  <p>
    The connection to the LRS is configured by a workflow which is run when the
    client is created.
  </p>

  {{#if @xapi}}
    <div class="row g-3">
      <div class="col-md-6">
        <label for="{{@uniqueId}}-xapi-key" class="form-label">Key</label>
        <input
          id="{{@uniqueId}}-xapi-key"
          name="xapi-key"
          type="text"
          class="form-control font-monospace"
          value={{@xapi.key}}
          disabled={{@isReadOnly}}
        />
        <div class="form-text">Authentication key for the LRS endpoint</div>
      </div>

      <div class="col-md-6">
        <label for="{{@uniqueId}}-xapi-secret" class="form-label">Secret</label>
        <input
          id="{{@uniqueId}}-xapi-secret"
          name="xapi-secret"
          type="password"
          class="form-control font-monospace"
          value={{@xapi.secret}}
          disabled={{@isReadOnly}}
        />
        <div class="form-text">Authentication secret for the LRS endpoint</div>
      </div>

      <div class="col-md-6">
        <label for="{{@uniqueId}}-xapi-lrsid" class="form-label">LRS ID</label>
        <input
          id="{{@uniqueId}}-xapi-lrsid"
          name="xapi-lrsid"
          type="text"
          class="form-control font-monospace"
          value={{@xapi.lrsid}}
          disabled={{@isReadOnly}}
        />
        <div class="form-text">Learning Record Store identifier</div>
      </div>
    </div>
  {{else}}
    <div class="alert alert-info mb-0">
      <p class="fw-bold"><iconify-icon inline icon="ph:info" />
        This client does not have a Learning Record Store set up.</p>
      <p>
        If this is a new client then it may take a few minutes for the
        configuration to be applied.</p>
      <p>
        If the problem persists then please contact the digital team.</p>
    </div>
  {{/if}}
</template>;

export default XapiSection;
